import {AnswerGroupSupervisor} from "../app/types";
import React, {ReactElement} from "react";
import ErrorAlert from "../common/components/ErrorAlert";
import FormContainer from "../common/form/FormContainer";
import {useForm} from "react-hook-form";
import {yupResolver} from "@hookform/resolvers/yup";
import {useFormSubmission} from "../common/servercall/useFormSubmission";
import * as yup from "yup";
import SupervisorSelection from "./premium/SupervisorSelection";
import {useSelector} from "react-redux";
import {selectedSiteSelector} from "../authentication/redux";

const schema = () => yup.object().shape(
    {

    }
)
export type SupervisorsFormType = {
    supervisors: AnswerGroupSupervisor[]
}

type Props = {
    supervisors: SupervisorsFormType
    onSubmit: (formData: SupervisorsFormType) => void
    readonly?: boolean
    buildFormButtons: (isSubmitting: boolean) => ReactElement
}

export const SupervisorsForm = ({ supervisors, onSubmit, buildFormButtons }: Props) => {
    const site = useSelector(selectedSiteSelector)

    const { control, handleSubmit, setError} = useForm({
        mode: 'onSubmit',
        resolver: yupResolver(schema()),
        defaultValues: supervisors
    })

    const { submit, isSubmitting, serverError, onError } = useFormSubmission<SupervisorsFormType>(onSubmit, setError)

    return <>
        <ErrorAlert showAlert={!!serverError} />
            <FormContainer onSubmit={handleSubmit(submit, onError)}>
                <SupervisorSelection control={control} site={site}/>
                {buildFormButtons(isSubmitting)}
            </FormContainer>
        </>
}
